// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
   production: false,
 //  razorpaykey: "rzp_live_qaOV9GYUa8LFwO",
  apiUrl: "https://api-bsnldirect.cinesoft.live/bsnl/",
   apiCMSUrl: "https://cms.cinesoft.live/api_chome_cp/",
   razorpaykey: "rzp_test_e7Xx5LjFWiAyVy",
  // apiCMSUrl: "https://cms.cinesoft.live/api_chome_test/", 
   // apiUrl:"https://api-bsnldirect.cinesoft.live/bsnl/",
// apiUrl:"http://localhost:8080/bsnl/"

//  razorpaykey: "rzp_live_qaOV9GYUa8LFwO",
 // apiCMSUrl: "https://cms.cinesoft.live/api_chome_cp/", 
 // apiUrl:"https://api-bsnldirect.cinesoft.live/bsnl/"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
